@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.settings.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mobile_wallet.feature.settings.generated.resources/"

internal val Res.string.feature_settings_alert_disable_account: StringResource by lazy {
      StringResource("string:feature_settings_alert_disable_account", "feature_settings_alert_disable_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 138, 102),
      ))
    }

internal val Res.string.feature_settings_alert_disable_account_desc: StringResource by lazy {
      StringResource("string:feature_settings_alert_disable_account_desc", "feature_settings_alert_disable_account_desc", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 127),
      ))
    }

internal val Res.string.feature_settings_cancel: StringResource by lazy {
      StringResource("string:feature_settings_cancel", "feature_settings_cancel", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 241, 39),
      ))
    }

internal val Res.string.feature_settings_change_passcode: StringResource by lazy {
      StringResource("string:feature_settings_change_passcode", "feature_settings_change_passcode", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 281, 60),
      ))
    }

internal val Res.string.feature_settings_change_password: StringResource by lazy {
      StringResource("string:feature_settings_change_password", "feature_settings_change_password", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 342, 60),
      ))
    }

internal val Res.string.feature_settings_disable_account: StringResource by lazy {
      StringResource("string:feature_settings_disable_account", "feature_settings_disable_account", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 403, 60),
      ))
    }

internal val Res.string.feature_settings_empty: StringResource by lazy {
      StringResource("string:feature_settings_empty", "feature_settings_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 464, 30),
      ))
    }

internal val Res.string.feature_settings_faq: StringResource by lazy {
      StringResource("string:feature_settings_faq", "feature_settings_faq", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 495, 32),
      ))
    }

internal val Res.string.feature_settings_log_out: StringResource by lazy {
      StringResource("string:feature_settings_log_out", "feature_settings_log_out", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 599, 44),
      ))
    }

internal val Res.string.feature_settings_log_out_title: StringResource by lazy {
      StringResource("string:feature_settings_log_out_title", "feature_settings_log_out_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 528, 70),
      ))
    }

internal val Res.string.feature_settings_no: StringResource by lazy {
      StringResource("string:feature_settings_no", "feature_settings_no", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 719, 31),
      ))
    }

internal val Res.string.feature_settings_notification_settings: StringResource by lazy {
      StringResource("string:feature_settings_notification_settings", "feature_settings_notification_settings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 644, 74),
      ))
    }

internal val Res.string.feature_settings_ok: StringResource by lazy {
      StringResource("string:feature_settings_ok", "feature_settings_ok", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 751, 31),
      ))
    }

internal val Res.string.feature_settings_settings: StringResource by lazy {
      StringResource("string:feature_settings_settings", "feature_settings_settings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 783, 45),
      ))
    }

internal val Res.string.feature_settings_yes: StringResource by lazy {
      StringResource("string:feature_settings_yes", "feature_settings_yes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 829, 32),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_settings_alert_disable_account", Res.string.feature_settings_alert_disable_account)
  map.put("feature_settings_alert_disable_account_desc", Res.string.feature_settings_alert_disable_account_desc)
  map.put("feature_settings_cancel", Res.string.feature_settings_cancel)
  map.put("feature_settings_change_passcode", Res.string.feature_settings_change_passcode)
  map.put("feature_settings_change_password", Res.string.feature_settings_change_password)
  map.put("feature_settings_disable_account", Res.string.feature_settings_disable_account)
  map.put("feature_settings_empty", Res.string.feature_settings_empty)
  map.put("feature_settings_faq", Res.string.feature_settings_faq)
  map.put("feature_settings_log_out", Res.string.feature_settings_log_out)
  map.put("feature_settings_log_out_title", Res.string.feature_settings_log_out_title)
  map.put("feature_settings_no", Res.string.feature_settings_no)
  map.put("feature_settings_notification_settings", Res.string.feature_settings_notification_settings)
  map.put("feature_settings_ok", Res.string.feature_settings_ok)
  map.put("feature_settings_settings", Res.string.feature_settings_settings)
  map.put("feature_settings_yes", Res.string.feature_settings_yes)
}
